module.exports = __webpack_public_path__ + "media/images/alluminium-2-11556aa6a3bdd24aa36bc61d771ba3d9.jpg";